import { RadioGroupField } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { useEffect, useState } from 'react'

import {
  computePaymentsEnabledState,
  getPaypalFormRowsVisibility,
} from './payment_provider_utils'

const buildProviderOptions = ({
  isProviderDisabled,
  isStripeEnabled,
  isPaypalLegacyEnabled,
  isPaypalPpcpEnabled,
  paypalRows,
}) => {
  const options = [{
    name: I18n.t('publisher.event_types.payment_method.do_not_collect_payments'),
    value: 'none',
    disabled: isProviderDisabled
  }, {
    name: I18n.t('publisher.event_types.payment_method.accept_stripe_payments'),
    value: 'stripe',
    disabled: !isStripeEnabled,
  }]
  if (paypalRows.showLegacyRow || paypalRows.showDisconnectedPaypalFallback) {
    options.push({
      name: I18n.t('publisher.event_types.payment_method.accept_paypal_payments'),
      value: 'paypal',
      disabled: !isPaypalLegacyEnabled,
    })
  }
  if (paypalRows.showPpcpRow) {
    options.push({
      name: I18n.t('publisher.event_types.payment_method.accept_paypal_ppcp_payments'),
      value: 'paypal_ppcp',
      disabled: !isPaypalPpcpEnabled,
    })
  }
  return options
}

// i18n-tasks-use t('publisher.event_types.payment_method.accept_stripe_payments')
// i18n-tasks-use t('publisher.event_types.payment_method.accept_paypal_payments')
// i18n-tasks-use t('publisher.event_types.payment_method.accept_paypal_ppcp_payments')
export const PaymentOptions = ({
  provider,
  isPaymentsIntegrationAvailable,
  paymentMethodEnabled,
  isStripeConnected,
  isPaypalConnected,
  isPaypalPpcpConnected = false,
  isPaypalPpcpFeatureEnabled = false,
}) => {
  const [isProviderDisabled, setIsProviderDisabled] = useState(false)
  const [stripeEnabled, setStripeEnabled] = useState(false)
  const [paypalLegacyEnabled, setPaypalLegacyEnabled] = useState(false)
  const [paypalPpcpEnabled, setPaypalPpcpEnabled] = useState(false)
  const isStripeDisconnected = paymentMethodEnabled && provider === 'stripe' && !isStripeConnected
  const isPaypalLegacyDisconnected = paymentMethodEnabled && provider === 'paypal' && !isPaypalConnected
  const isPaypalPpcpDisconnected = paymentMethodEnabled && provider === 'paypal_ppcp' && !isPaypalPpcpConnected
  const isPaypalDisconnected = isPaypalLegacyDisconnected || isPaypalPpcpDisconnected

  const paypalRows = getPaypalFormRowsVisibility({
    isPaypalConnected,
    isPaypalPpcpConnected,
    provider,
  })

  useEffect(() => {
    const ui = computePaymentsEnabledState({
      isPaymentsIntegrationAvailable,
      isPaypalConnected,
      isPaypalPpcpConnected,
      isPaypalPpcpFeatureEnabled,
      isPaypalDisconnected,
      isStripeConnected,
      isStripeDisconnected,
      paymentMethodEnabled,
      provider
    })

    setIsProviderDisabled(ui.isProviderDisabled)
    setStripeEnabled(ui.isStripeEnabled)
    setPaypalLegacyEnabled(ui.isPaypalLegacyEnabled)
    setPaypalPpcpEnabled(ui.isPaypalPpcpEnabled)
  }, [
    isPaymentsIntegrationAvailable,
    isPaypalConnected,
    isPaypalPpcpConnected,
    isPaypalPpcpFeatureEnabled,
    isPaypalDisconnected,
    isStripeConnected,
    isStripeDisconnected,
    paymentMethodEnabled,
    provider
  ])

  const providerOptions = buildProviderOptions({
    isProviderDisabled,
    isStripeEnabled: stripeEnabled,
    isPaypalLegacyEnabled: paypalLegacyEnabled,
    isPaypalPpcpEnabled: paypalPpcpEnabled,
    paypalRows,
  })

  return (
    <RadioGroupField
      name="provider"
      options={providerOptions}
    />
  )
}
